import React from 'react';

export default function Editor() {
  return <p>HTML HERE</p>;
}
